module.exports = __webpack_public_path__ + "img/score_3.1b0a41d0.png";